
const digest = '54b18fddf29edb597c13c1338833f66b0095246199a14fb3189706dd00024e40';
const classes = {"wrapper":"_wrapper_30mcp_1","text":"_text_30mcp_10"};
const css = `._wrapper_30mcp_1 {
  font-family: "Rubik", sans-serif;
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  gap: 12px;
  font-size: 14px;
}

._text_30mcp_10 {
  font-weight: 500;
  color: #f12848;
  border: 1px solid #f12848;
  padding: 20px;
  font-size: 14px;
  width: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  